import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { SectionLabel } from "../components/Shared";
import CTABanner from "../components/CTABanner";
import { INSIGHTS, IMAGES } from "../config/siteConfig";
import { stagger, fadeUp, viewportOnce } from "../lib/motion";

export default function Insights() {
  return (
    <>
      <PageHero
        label="Insights"
        title="Perspectives on talent,"
        highlight="hiring, and growth."
        subtitle="Practical thinking on recruitment, workforce strategy, and the fast-moving GCC talent market."
        image={IMAGES.hero}
      />
      <section className="bg-[#F7F7F5] py-24 md:py-36" data-testid="insights-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionLabel>Latest Thinking</SectionLabel>
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="grid md:grid-cols-2 gap-6 mt-8"
          >
            {INSIGHTS.map((a, i) => (
              <motion.article
                key={i}
                variants={fadeUp}
                data-testid={`insight-${i}`}
                className="group bg-white border border-black/10 rounded-sm p-8 md:p-10 hover:border-[#C62828] hover:shadow-[0_18px_40px_-24px_rgba(198,40,40,0.5)] transition-all duration-400 cursor-pointer"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="overline text-[10px] text-[#C62828]">{a.category}</span>
                  <span className="font-body text-xs text-[#999]">{a.date}</span>
                </div>
                <h2 className="font-display text-2xl md:text-3xl text-[#111111] leading-snug group-hover:text-[#C62828] transition-colors">
                  {a.title}
                </h2>
                <p className="font-body text-[#555] mt-4 leading-relaxed">{a.excerpt}</p>
                <span className="inline-flex items-center gap-1 mt-6 overline text-[10px] text-[#111] group-hover:text-[#C62828] transition-colors">
                  Read Article <ArrowUpRight size={13} />
                </span>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </section>
      <CTABanner heading="Have a hiring challenge worth discussing?" highlight="Reach out." secondary={null} />
    </>
  );
}
